import { useInfiniteQuery, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  getOpenMarketProducts,
  IGetOpenMarketProductsParams,
} from '../../../../api/product/queries/getOpenMarketProducts';
import { IOpenMarketProduct } from '../../../../interfaces/OpenMarketProduct.interfaces';

interface IUseInfiniteOpenMarketProductsParams extends IGetOpenMarketProductsParams {
  options?: UseInfiniteQueryOptions<IOpenMarketProduct[], AxiosError>;
}

export const useInfiniteOpenMarketProducts = ({ searchParam, options }: IUseInfiniteOpenMarketProductsParams) => {
  return useInfiniteQuery<IOpenMarketProduct[], AxiosError>(
    [
      'user-sell-tractors',
      `status=${searchParam?.status}`,
      `count=${searchParam?.count}`,
      `machineType=${searchParam?.machineType}`,
      `machineId=${searchParam?.machineId}`,
      `brand=${searchParam?.brand}`,
      `minEngineOutputPs=${searchParam?.minEngineOutputPs}`,
      `maxEngineOutputPs=${searchParam?.maxEngineOutputPs}`,
      `minPrice=${searchParam?.minPrice}`,
      `maxPrice=${searchParam?.maxPrice}`,
      `sort=${searchParam?.sort}`,
      `rowConfig=${searchParam?.rowConfig}`,
      `minOperationTime=${searchParam?.minOperationTime}`,
      `maxOperationTime=${searchParam?.maxOperationTime}`,
    ],
    ({ pageParam = 1 }) =>
      getOpenMarketProducts({
        searchParam: {
          ...searchParam,
          machineType: searchParam?.machineType === 'ALL' ? '' : searchParam?.machineType,
          status: searchParam?.status === 'ALL' ? '' : searchParam?.status,
          page: pageParam,
        },
      }),
    {
      ...options,
      getNextPageParam: (lastPage, allPages) => {
        const nextPage = allPages.length + 1;
        return lastPage?.length === 0 || lastPage?.length < searchParam.count ? undefined : nextPage;
      },
    },
  );
};
